import React from 'react';

import Tag from '../../../Tag';
import Button from '../../../Button';

const BodyCell = ({value, ...props}) => {

	if(value){
		const {
			title,
			subtitle,
			tagProps,
			buttonProps,
			iconProps
		} = value;
	
		const {column} = props;

		return (
			<>
			<span className="rt-td__head">{column.header ? column.header : column.Header}</span>
				{/* <span className="rt-td__head">{ typeof column.Header === 'object' ? 'NAME' : column.Header}</span> */}
				<span className="rt-td__cell">
					{iconProps && (<img className={iconProps.className} src={iconProps.avatar} alt="personAvatar"/>)}
					{title && (<span className={"rt-td__content"}>{title}</span>)}
					{subtitle && (<span className={"rt-td__small"}>{subtitle}</span>)}
					{tagProps && (< Tag className="body-cell__tag" {...tagProps} />)}
					{buttonProps && (<Button className="body-cell__button" {...buttonProps} />)}
				</span>
			</>
		)
	}
	return ( <span className="rt-td__cell"/>)

};

export default BodyCell;
